import React from 'react';
import GroupLightComponent from './configs/LightGroupConfig';
import {GruposPaginas} from '../../configs/iluminação'

const TerreoPagina = () => {
  console.log(GruposPaginas)
  return (
    <div className="terreo-container">
      <h1>Controle de Iluminação - Térreo</h1>
      <GroupLightComponent
        groupIds={GruposPaginas[0]}
        pageTitle="Luzes do Térreo" 
        pageId="2"
      />
    </div>
  );
};

export default TerreoPagina;